import React from 'react'

const TrackerTotalItems = ({icon, title, number}) => {
  return (
    <>
        <div className="col-md-4 mb-3 mb-md-0">
            <div className="total-tracker d-flex flex-column shadow">
                <div className="mb-2">
                    <img
                        src={icon}
                        alt="total "
                    />
                </div>
                <div className="total-title">
                        <p className="mb-1">{title}</p>
                </div>
                <div className="total-number">
                    <p className="mb-0">{number}</p>
                </div>
            </div>
        </div>
    </>
  )
}

export default TrackerTotalItems
